<template>
    <div v-pml-block="isLoading" class="bg_load_null">
        <pml-pagination :source="pagination" @navigate="fetchList"></pml-pagination>
        <div style="min-height: 100px;">
            <PmlItem v-for="item in list" :key="item.id" :item="item" @deleted="deleted"></PmlItem>
            <div v-if="!list.length" class="text-center p-t-40"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</div>
        </div>
        <pml-pagination :source="pagination" @navigate="fetchList"></pml-pagination>
    </div>
</template>

<script>
    import PmlItem from './Item.vue'
    import bus from 'utils/events/bus'
    import { removeById } from 'utils/helpers/arrays'

    export default {
        name: 'DealsList',
        components: { PmlItem },
        data () {
            return {
                pagination: {},
                isLoading: false
            }
        },
        created () {
            bus.$on('paginationRefreshDeals', (data) => { this.pagination = data })
            bus.$on('listLoadingDeals', (bool) => { this.isLoading = bool })
        },
        destroyed () {
            bus.$off('paginationRefreshDeals')
            bus.$off('listLoadingDeals')
        },
        computed: {
            list () {
                return this.pagination.data || []
            }
        },
        methods: {
            fetchList (page = 1) {
                bus.$emit('doFilterDeals', page)
            },
            deleted (id) {
                removeById(this.pagination.data, id)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/list/List.vue